import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CaseDropdownsState } from '../reducers/dropdown.reducer';

export const selectDropdownState = createFeatureSelector<CaseDropdownsState>('dropdownsReducer');

// Dinamik selector: Sadece tanımlı key’leri alabilir
export const selectDropdownOptions = <T extends keyof CaseDropdownsState>(key: T) =>
  createSelector(selectDropdownState, (state) => state[key]);


export const selectDropdownLoaded = createSelector(
  selectDropdownState,
  state => state.loaded
);
